import {
  DownloadIcon_default
} from "./chunk-SL4PMKHM.mjs";
export {
  DownloadIcon_default as default
};
